import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=c31512da&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=c31512da&scoped=true&lang=less"
import style1 from "./CommonHeader.vue?vue&type=style&index=1&id=c31512da&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31512da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31512da')) {
      api.createRecord('c31512da', component.options)
    } else {
      api.reload('c31512da', component.options)
    }
    module.hot.accept("./CommonHeader.vue?vue&type=template&id=c31512da&scoped=true", function () {
      api.rerender('c31512da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/CommonHeader.vue"
export default component.exports